import React from "react";
import birthday from "../../../../assets/dashboard/birthday.jpg";
import { baseURLImage, getNameProfile, formatDateToAustralian, capitalizeFirstLetter } from "Utils/utils";

const BirthdayCard = ({ item }) => {
 
  const backgroundImageStyle = {
    backgroundImage: `url(${birthday})`,
    backgroundSize: "cover", // Adjust as needed
    backgroundRepeat: "no-repeat", // Adjust as needed
  
  };

  const isToday = (date) => {
    const today = new Date();
    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth();
  };

  // Usage example:
  const dob = new Date(item?.dob);
  const isBirthdayToday = isToday(dob);

  const handleImageError = (e, fname, lname) => {
    return (e.target.src = getNameProfile(fname, lname));
  };

  return (
    <div className="bg-gradient-to-br from-pink-50 via-rose-50 to-pink-100 border border-pink-200 rounded-lg p-3 sm:p-4 hover:shadow-md transition-all duration-200 group">
      <div className="flex items-center gap-2 sm:gap-3">
        <div className="relative h-10 w-10 sm:h-12 sm:w-12 flex-shrink-0">
          <img
            onError={(e) => handleImageError(e, item?.name, item?.name)}
            className="object-cover h-10 w-10 sm:h-12 sm:w-12 rounded-full ring-2 ring-pink-300 group-hover:ring-pink-400 transition-all"
            src={
              item?.photo
                ? baseURLImage(item?.photo)
                : getNameProfile(item.name, item?.name || " ")
            }
            alt=""
          />
          {isBirthdayToday && (
            <div className="absolute -top-1 -right-1 h-3 w-3 sm:h-4 sm:w-4 bg-red-500 rounded-full border-2 border-white animate-pulse"></div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-xs sm:text-sm text-gray-900 truncate">
            {capitalizeFirstLetter(item?.name || '')}
          </div>
          <div className="text-[10px] sm:text-xs text-gray-600 mt-0.5">
            {item?.type && <span className="text-gray-500">({item?.type})</span>}
          </div>
          <div className={`text-[10px] sm:text-xs font-medium mt-1 ${isBirthdayToday ? 'text-red-600' : 'text-gray-600'}`}>
            {isBirthdayToday ? (
              <span className="flex items-center gap-1">
                <span className="inline-block w-1.5 h-1.5 sm:w-2 sm:h-2 bg-red-500 rounded-full animate-pulse"></span>
                <span className="truncate">Birthday Today! 🎉</span>
              </span>
            ) : (
              <span className="truncate">Birthday on {formatDateToAustralian(item?.dob)}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BirthdayCard;
